import * as amplitude from '@amplitude/analytics-browser';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AnalyticsEventType } from './analyticsEvents';

export function PageTracker() {
    const location = useLocation();
    const previousPathname = useRef<string | null>(null);

    useEffect(() => {
        const properties = {
            '[Amplitude] Page Path': location.pathname,
            '[Amplitude] Previous Page Location': previousPathname.current || '',
        };
        
        amplitude.track(AnalyticsEventType.PAGE_VIEWED, properties);
        previousPathname.current = location.pathname;
    }, [location]);

    return null;
}
